var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6718 22.5041L25.1928 26.7255C25.3264 27.8343 24.1374 28.6091 23.1889 28.0347L17.5916 24.7083C16.9771 24.7083 16.3759 24.6683 15.7881 24.5881C16.7767 23.4259 17.3645 21.9564 17.3645 20.3667C17.3645 16.5727 14.0782 13.5003 10.0171 13.5003C8.46744 13.5003 7.03804 13.9411 5.8491 14.7159C5.80902 14.3819 5.79565 14.0479 5.79565 13.7006C5.79565 7.62229 11.0724 2.69287 17.5916 2.69287C24.1107 2.69287 29.3875 7.62229 29.3875 13.7006C29.3875 17.3075 27.5306 20.5003 24.6718 22.5041Z",
    stroke: "#FEFEFE",
    strokeWidth: 2.00383,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3664 20.3667C17.3664 21.9564 16.7786 23.4259 15.7901 24.5881C14.4675 26.1912 12.3702 27.2198 10.019 27.2198L6.53235 29.2904C5.94456 29.6511 5.19646 29.1568 5.27661 28.4755L5.61058 25.8439C3.82049 24.6015 2.67163 22.6109 2.67163 20.3667C2.67163 18.0155 3.92737 15.9449 5.85105 14.7159C7.04 13.9411 8.46939 13.5002 10.019 13.5002C14.0801 13.5002 17.3664 16.5727 17.3664 20.3667Z",
    stroke: "#FEFEFE",
    strokeWidth: 2.00383,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages);
export default __webpack_public_path__ + "static/media/messages.d3e950d9.svg";
export { ForwardRef as ReactComponent };